module.exports = __webpack_public_path__ + "78c1973d6390d76a54212bdab04e44e9.glb";